<template>
  <div>
    <el-dialog
      top="5vh"
      title="修改状态"
      :visible.sync="dialogFormVisible"
      @close="handleToClose"
      :close-on-click-modal="false"
      width="857px"
    >
      <el-form
        :model="dataForm"
        label-position="right"
        ref="formRules"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <el-form-item
          label="确认："
          prop="confirm_status"
        >
          <el-switch
            v-model="dataForm.confirm_status"
            :active-value="1"
            :inactive-value="0"
            active-text="有效联系方式"
            :disabled="dataForm.confirm_status==1"
          > </el-switch>
        </el-form-item>
        <el-form-item
          label="状态："
          prop="status"
          v-if="dataForm.confirm_status==1"
        >
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">待跟进</el-radio>
            <el-radio :label="1">已跟进</el-radio>
            <el-radio :label="2">已报名</el-radio>
            <el-radio :label="3">未报名</el-radio>
            <el-radio :label="4">已失效</el-radio>
            <el-radio :label="5">结佣中</el-radio>
            <el-radio :label="6">已结佣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="状态："
          prop="status"
          v-if="dataForm.confirm_status==0"
        >
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">待跟进</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="咨询师："
          prop="consult_manage_name"
        >
          <el-input
            v-model="dataForm.consult_manage_name"
            placeholder="请输入名称"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleToClose()">取消</el-button>
        <el-button
          type="primary"
          @click="submit('formRules')"
          slot=""
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
       <script>



import {
  seniorStudentOne,
  seniorStudentEdit
} from "@/api/distribution";



export default {
  components: {
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      dataForm: {
      },
      rules: {
        status: [{ required: true, message: "请选择状态", trigger: "blur" }],
        confirm_status: [{ required: true, message: "请选择确认状态", trigger: "blur" }],

      },

    };
  },
  mounted() {

  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val;
      if (val) {
        this.fetchDetail()
        console.log(this.id);
      }
    },
  },
  methods: {
    fetchDetail() {
      seniorStudentOne({ id: this.id }).then((res) => {
        this.dataForm = res
      });
    },
    handleToClose() {
      this.$emit("close");
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let data = {
            id: this.dataForm.id,
            apply_year: this.dataForm.apply_year,
            consult_manage_name: this.dataForm.consult_manage_name,
            status: this.dataForm.status,
            confirm_status: this.dataForm.confirm_status,
          }
          seniorStudentEdit(data).then((res) => {
            if (res == null) {
              this.$message.success('操作成功')
              this.$emit('submit')
              this.handleToClose()
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },



  },
};
        </script>
        
        <style lang="less" scoped>
</style>